"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appLanguageBase = void 0;
var tslib_1 = require("tslib");
var appLanguageBaseDefault_1 = require("./appLanguageBaseDefault");
var _appLanguage = tslib_1.__assign({}, appLanguageBaseDefault_1.appLanguageBaseDefault);
var appLanguageBase = function () {
    return _appLanguage;
};
exports.appLanguageBase = appLanguageBase;
exports.appLanguageBase.extends = function (appLanguage) {
    _appLanguage = appLanguage;
    return function () {
        return appLanguage;
    };
};
